<div class="login-dialog">
    <form class="login-form" [formGroup]="formGroup" (keydown.enter)="onSubmit()">
        <div class="login-caption">
            <h3>Log in to Xanadu</h3>
        </div>
        <div class="login-credentials">
            <div class="login-email">
                <app-email [formGroup]="formGroup" [model]="data.email" [meta]="metaEmail" [readonly]="pendingLogin"></app-email>
            </div>
            <div class="login-password">
                <app-password [formGroup]="formGroup" [model]="data.password" [meta]="metaPass" [readonly]="pendingLogin"></app-password>
            </div>
        </div>
        <div class="login-actions">

            <button class="button" [disabled]="loginDisabled() || pendingLogin" (click)="onSubmit()">
                @if (!pendingLogin) {
                <mat-icon class="regular-icon">login</mat-icon> Login
                }
                @if (pendingLogin) {
                <mat-icon class="regular-icon">hourglass_top</mat-icon> Logging in...
                }
            </button>
        </div>
    </form>
</div>
